import { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useApi } from "../../hooks/useApi";
import { api, toList } from "../../lib/api";
import { PageHeader, Loader, ErrorNote, Empty, shortDate } from "../../components/app/kit";
import { ThreadView } from "../../components/app/ThreadView";

export const ThreadList = ({ threads, active, onPick, labelOf }) => (
  <ul className="space-y-2">
    {threads.map((t, i) => {
      const key = `${t.recruiter_id}-${t.player_id}`;
      const on = active === key;
      return (
        <li key={key ?? i}>
          <button data-testid={`thread-item-${i}`} onClick={() => onPick(t)} className={`w-full rounded-2xl border px-4 py-3 text-left transition-colors ${on ? "border-[#39FF14]/60 bg-[#162032]" : "border-[#1E293B] bg-[#0F172A] hover:border-slate-600"}`}>
            <div className="flex items-center justify-between gap-2">
              <p className="truncate font-semibold text-white">{labelOf(t)}</p>
              {t.unread && <span className="h-2 w-2 shrink-0 rounded-full bg-[#39FF14]" />}
            </div>
            <p className="truncate text-sm text-slate-400">{t.last_body}</p>
            <p className="font-mono-gd text-[10px] uppercase tracking-wider text-slate-500">{shortDate(t.last_at)}</p>
          </button>
        </li>
      );
    })}
  </ul>
);

export default function CoachMessages() {
  const { membership } = useAuth();
  const tid = membership?.team_id;
  const list = useApi(tid && `/teams/${tid}/messages`);
  const [sel, setSel] = useState(null);
  const threadPath = sel && `/teams/${tid}/messages/thread?recruiter_id=${sel.recruiter_id}&player_id=${sel.player_id}`;
  const thread = useApi(threadPath);
  const threads = toList(list.data, ["threads"]);
  const msgs = toList(thread.data, ["messages"]);

  const send = async (body) => {
    await api.post(`/teams/${tid}/messages/reply?recruiter_id=${sel.recruiter_id}&player_id=${sel.player_id}`, { body });
    thread.reload();
    list.reload();
  };

  return (
    <div>
      <PageHeader eyebrow="Coach ↔ recruiter" title="Messages" />
      {list.loading ? <Loader /> : list.error ? <ErrorNote error={list.error} /> : !threads.length ? <Empty title="No conversations" text="When a college recruiter messages about one of your players, it lands here." /> : (
        <div className="grid gap-6 lg:grid-cols-[340px_1fr]">
          <ThreadList threads={threads} active={sel && `${sel.recruiter_id}-${sel.player_id}`} onPick={setSel} labelOf={(t) => `${t.recruiter_org ?? t.recruiter_name} · ${t.player_name ?? "Player"}`} />
          {sel ? (thread.loading && !thread.data ? <Loader /> : (
            <ThreadView messages={msgs} mineSender="coach" onSend={send} title={`${sel.recruiter_name ?? "Recruiter"} · ${sel.recruiter_org ?? ""}`} subtitle={`About ${sel.player_name ?? "player"}`} />
          )) : <Empty title="Pick a conversation" />}
        </div>
      )}
    </div>
  );
}
